var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayableFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payable",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "budget",
    transform: "translate(82.5 232.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M121.242,125.279a4.482,4.482,0,1,0,4.482-4.482A4.487,4.487,0,0,0,121.242,125.279Zm5.007.752a.71.71,0,0,0-.209-.136,2.273,2.273,0,0,0-.316-.113l-.4-.116a3.436,3.436,0,0,1-.492-.188,1.3,1.3,0,0,1-.345-.235.85.85,0,0,1-.2-.307,1.131,1.131,0,0,1-.067-.405,1.289,1.289,0,0,1,.122-.573,1.238,1.238,0,0,1,.33-.42,1.441,1.441,0,0,1,.484-.258l.065-.019v-.77h1v.755a3.129,3.129,0,0,1,.342.092,2.88,2.88,0,0,1,.356.145q.165.081.3.162l-.417.788a.583.583,0,0,0-.122-.087,2.3,2.3,0,0,0-.261-.133,2.527,2.527,0,0,0-.342-.122,1.364,1.364,0,0,0-.371-.052q-.51,0-.51.342a.271.271,0,0,0,.055.174.485.485,0,0,0,.162.125,1.493,1.493,0,0,0,.269.1q.162.046.377.1a4.941,4.941,0,0,1,.533.177,1.429,1.429,0,0,1,.4.237.961.961,0,0,1,.255.345,1.2,1.2,0,0,1,.09.487,1.219,1.219,0,0,1-.13.588,1.1,1.1,0,0,1-.345.388,1.456,1.456,0,0,1-.492.214c-.052.012-.1.023-.157.032v.771h-1v-.79a3.313,3.313,0,0,1-.346-.082,3.662,3.662,0,0,1-.437-.159,2.442,2.442,0,0,1-.391-.214l.417-.828a.806.806,0,0,0,.151.11,2.24,2.24,0,0,0,.316.162,3.185,3.185,0,0,0,.42.145,1.759,1.759,0,0,0,.469.064q.5,0,.5-.307A.259.259,0,0,0,126.25,126.03Zm0,0",
    transform: "translate(-117.217 -116.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M271.238,3.037A5.487,5.487,0,0,1,276.2,7.994h3.037A8.506,8.506,0,0,0,271.238,0Zm0,0",
    transform: "translate(-262.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    d: "M13.963,8.991A5.479,5.479,0,1,1,8.009,3.037V0A8.507,8.507,0,0,0,2.492,14.508,8.507,8.507,0,0,0,17,8.991Zm0,0",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayableFill);
export default __webpack_public_path__ + "static/media/payableFill.9a25dbd2c8f2d7a5fea7ca3ae821fdce.svg";
export { ForwardRef as ReactComponent };